import type { CrawlerType } from '../domain/character.ts';

/**
 * AI Favor.
 * RULE DCC-FAVOR-001 - Crawlers & Customization p.16.
 * A human crawler starts with 1 AI Favor. An animal crawler starts with none,
 * having spent it to become an animal (see also C&C p.10).
 *
 * RULE DCC-FAVOR-002 - spending 1 point does one of two things:
 *  - once per Check, reroll a d20 before the GM announces the result, EXCEPT a
 *    natural 1, which is an automatic Critical Fail and cannot be rerolled;
 *  - once per round, gain one extra non-Attack Action in combat.
 */
export function startingAiFavor(crawlerType: CrawlerType): number {
  return crawlerType === 'human' ? 1 : 0;
}

export type AiFavorUse = 'reroll-d20' | 'extra-non-attack-action';

export type SpendAiFavorResult =
  | { ok: true; remaining: number }
  | { ok: false; reason: string };

export function spendAiFavor(
  current: number,
  use: AiFavorUse,
  context: { dieFace?: number } = {},
): SpendAiFavorResult {
  if (current < 1) {
    return { ok: false, reason: 'No AI Favor remaining.' };
  }
  if (use === 'reroll-d20' && context.dieFace === 1) {
    return {
      ok: false,
      reason: 'A natural 1 is an automatic Critical Fail and cannot be rerolled (C&C p.16).',
    };
  }
  return { ok: true, remaining: current - 1 };
}
